import React from 'react';
import RootSvg, { RootSvgProps } from '@/components/icons/RootSvg';

export default function SvgArrow(props: RootSvgProps) {
  return (
    <RootSvg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.2426 7.75736L15.1317 11.6464C15.327 11.8417 15.327 12.1583 15.1317 12.3536L11.2426 16.2426"
        stroke="#2D2D2D"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </RootSvg>
  );
}
